import { render, staticRenderFns } from "./PayMethod.vue?vue&type=template&id=dc265ea6&scoped=true&"
import script from "./PayMethod.vue?vue&type=script&lang=js&"
export * from "./PayMethod.vue?vue&type=script&lang=js&"
import style0 from "./PayMethod.vue?vue&type=style&index=0&id=dc265ea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc265ea6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAlert,VCard,VCardText,VDialog,VProgressLinear})
